export const ACTION_GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS = "ACTION_GET_SUBCATEGORIES_MARKETPLACE_PRODUCTS";
export const ACTION_GET_CATEGORIES_MARKETPLACE_PRODUCTS = "ACTION_GET_CATEGORIES_MARKETPLACE_PRODUCTS";
export const ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT = "ACTION_GET_COMPANIES_LIST_TYPE_DOCUMENT";
export const ACTION_POST_CREATE_MARKETPLACE_PRODUCTS = "ACTION_POST_CREATE_MARKETPLACE_PRODUCTS";
export const ACTION_GET_ALL_MONETIZATION_TYPES = "ACTION_GET_ALL_MONETIZATION_TYPES";
export const ACTION_POST_CREATE_COMPANIES = "ACTION_POST_CREATE_COMPANIES";
export const ACTION_PUT_UPDATE_COMPANIES = "ACTION_PUT_UPDATE_COMPANIES";
export const ACTION_GET_FUNCTIONALITIES = "ACTION_GET_FUNCTIONALITIES";
export const ACTION_GET_COMPANY_BY_ID = "ACTION_GET_COMPANY_BY_ID";
export const ACTION_DELETE_COMPANIES = "ACTION_DELETE_COMPANIES";
export const ACTION_GET_COMPANIES = "ACTION_GET_COMPANIES";